<template>
  <div>
    <vue-modal :open="open">
      <div class="bax-modal-content bax-modal-icon-content text-center">
        <div v-if="!showSplitForm">
          <div class="bax-icon bax-remove d-flex align-items-center justify-content-center">
            <i class="icon-exclamation"></i>
          </div>
          <h2>Drug volume exceeds container size</h2>
          <p class="text-center">Would you like to split this order line into multiple doses?</p>
          <div class="bax-modal-action-items">
            <ul class="d-md-flex justify-content-center">
              <li>
                <a href="#" class="bax-btn bax-btn-gray mt-3 mt-md-0" @click.prevent="doNotSplit"
                  >No, go back</a
                >
              </li>
              <li>
                <a
                  href="#"
                  class="bax-btn bax-btn-orange mt-3 mt-md-0"
                  @click.prevent="handleShowSplitForm"
                >
                  <span>Yes, continue</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div v-if="showSplitForm">
          <div class="align-items-start justify-content-start">
            <p>
              <strong>
                Split {{ drug.dosage }}{{ drug.unit }} of {{ drug.name }} into multiple doses
              </strong>
            </p>
            <!-- New Form Here -->

            <div class="bax-form-group align-items-start justify-content-start text-left">
              <div class="bax-form-group align-items-start justify-content-start text-left">
                <strong><label for="doseSelect">Number of doses:</label></strong>
              </div>
              <div class="bax-form-group bax-xs">
                <select id="doseSelect" name="doseSelect" v-model="selectedDoses">
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                </select>
              </div>
            </div>
          </div>
          <div
            v-for="(dose, index) in parseInt(selectedDoses)"
            :key="dose"
            class="bax-inline-element d-md-flex"
          >
            <div class="bax-form-group bax-xs">
              <label>Dose</label>
              <input
                class="bax-input-control"
                type="text"
                v-model="dosesValues[`dose${dose}`]['dose']"
                @input="debouncedDoseChange(index + 1, dosesValues[`dose${dose}`]['dose'])"
                min="0"
              />
              <p
                class="error"
              >
                {{ dosageErrors[`dose${dose}`] }}
              </p>
            </div>
            <div class="bax-form-group bax-xs">
              <label>Unit</label>
              <input class="bax-input-control" type="text" disabled v-model="drug.unit" />
            </div>
          </div>
          <div class="bax-modal-action-items mt-4">
            <ul class="d-md-flex justify-content-center">
              <li>
                <a href="#" class="bax-btn bax-btn-gray mt-md-0" @click.prevent="doNotSplit"
                  >No, go back</a
                >
              </li>
              <li>
                <a
                  href="#"
                  class="bax-btn bax-btn-orange mt-md-0"
                  @click.prevent="handleAddDosesToOrder"
                  :class="validForm?'':'disabled'"
                >
                  <span>Add doses to order</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </vue-modal>
  </div>
</template>

<script>

export default {
  name: "ExceedContainerSizeModal",
  props: {
    open: {
      type: Boolean,
    },
    drug: {
      type: Object,
    },
    dosages: {
      type: Array,
    },
  },
  mounted() {
  },
  data() {
    return {
      showSplitForm: false,
      validForm: false,
      selectedDoses: 1,
      dosesValues: {
        dose1: { dose: null }
      },
      dosageErrors: {
        dose1: ''
      },

      debouncedDoseChange: this.debounce(this.handleDoseInputChange, 500),
    };
  },
  watch: {
    selectedDoses() {
      this.dosesValues = { dose1: { dose: null } };
      // Split the dosage into equal parts
      for (let i = 1; i <= this.selectedDoses; i += 1) {
        this.$set(this.dosesValues, `dose${i}`, {
          dose: Math.round((this.drug.dosage / this.selectedDoses) * 10) / 10,
        });
        this.$set(this.dosageErrors, `dose${i}`, '');
        this.handleDoseInputChange(1);
      }
    },
  },
  methods: {
    debounce(func, delay) {
      let timeoutId;
      return function (...args) {
        if (timeoutId) {
          clearTimeout(timeoutId);
        }
        timeoutId = setTimeout(() => {
          func.apply(this, args);
        }, delay);
      };
    },
    totalDosaged(index) {
      let totalDosed = 0;
      for (let i = 1; i <= index; i += 1) {
        totalDosed += parseFloat(this.dosesValues["dose" + i].dose);
      }

      return totalDosed;
    },
    handleAddDosesToOrder() {
      // Validate the dosage split
      if (this.totalDosaged(this.selectedDoses) !== parseInt(this.drug.dosage, 10)) {
        alert("Dosage split does not equal total drug dosage");
      } else {
        this.showSplitForm = false;
        this.$emit("updateDosesVolumes", this.dosesValues);
      }
    },
    handleShowSplitForm() {
      this.selectedDoses = 1;
      this.dosesValues = {
        dose1: { dose: null }
      }
      this.dosesValues.dose1.dose = this.drug.dosage;
      this.showSplitForm = true;
    },
    doNotSplit() {
      this.showSplitForm = false;
      this.$emit("doNotSplitDosageIntoContainers");
    },
    handleDoseInputChange(index) {
      const numDoses = this.selectedDoses;
      const totalDosed = this.totalDosaged(index);

      // Split the remaining inputs equally with remaining dose required
      for (let i = index + 1; i <= numDoses; i += 1) {
        if (i <= numDoses) {
          this.$set(this.dosesValues, `dose${i}`, {
            dose: (this.drug.dosage - totalDosed) / (numDoses - index),
          });
        }
      }
      this.validForm = true;
      for (let i = 1; i <= numDoses; i += 1) {
        if (parseFloat(this.dosesValues["dose" + i].dose) <= 0) {
          this.validForm = false;
          this.dosageErrors["dose" + i] = 'Dosage must be greater than 0';
        } else if (this.totalDosaged(this.selectedDoses) !== parseInt(this.drug.dosage, 10)) {
          this.dosageErrors.dose1 = 'Dosage split does not equal total drug dosage';
        } else {
          this.validForm = true;
          this.dosageErrors["dose" + i] = '';
        }
      }
    },
    initializeDoses() {
    },
  },
};
</script>
<style scoped lang="scss">
  p.error {
    color:red;
    font-size: 12px;
    line-height: 16px;
    margin-top: 4px;
  }

  a.disabled {
    pointer-events: none;
    background-color: #efefef;
  }
</style>
